//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'error',
  data () {
    return {
     noneImage: '../assets/img/404.png'
    }
  },
  created(){  //页面初始化加载的函数

    //this.loginBtn()

  },
  methods:{
   /* loginBtn : async function(){
      /!*  clearTimeout(int)*!/
      let params = {
        url:"http://lyx.allinpaynmg.cn",
      }
      console.log(params)
      const res = await this.$api.get("openidTest", params)
      let redirecturl = res.data.data.url;
      window.location.href=redirecturl;
      console.log(res)
     /!* if(res.data.code == "0000"){
        console.log(res.data.data.token)


      }else {
        this.$vux.toast.show({
          text: res.data.msg,
          type: "warn"
        })
      }*!/

    }*/
  }
}



// WEBPACK FOOTER //
// ./src/components/404.vue